import { useState } from 'react'
import { useEffect } from 'react'
import { NewsBanner } from '@modules/Base/components/Banner'

import { InjectionTokens } from '@/controller/tokens'

import { LocalStorageKeyValuePersister } from '@/infra/keyValuePersister/LocalStorageKeyValuePersister'
import { useInjection } from '@/presentation/contexts/InjectionContext'

const STORAGE_KEY = 'show-news-banner'

function NewsBannerPresenter() {
  const persister = useInjection<LocalStorageKeyValuePersister>(InjectionTokens.KeyValuePersister)
  const [show, setShow] = useState(false)

  useEffect(() => {
    const checkBannerStatus = async () => {
      const result = await persister.get(STORAGE_KEY)
      if (result.isFailure) {
        setShow(true) // Show banner if there's an error retrieving the value
      } else {
        const value = result.getValue()
        setShow(value === null ? true : JSON.parse(value)) // Show banner if value is null or true
      }
    }

    checkBannerStatus()
  }, [persister])

  const handleClose = () => {
    setShow(false)
    persister.set(STORAGE_KEY, JSON.stringify(false))
  }

  if (!show) return null
  return <NewsBanner onClose={handleClose} />
}

export { NewsBannerPresenter }
